import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from '@fiverr-private/icons';
import Modal from '..';

import { ModalCloseBtnCSS, ModalCloseBtnProps } from '../types';
import styles from './index.module.scss';

const ModalCloseBtn: React.FC<ModalCloseBtnProps>  = ({
    onClick = () => undefined,
    className,
    iconClassName,
    iconColor,
    hasBackground = true,
    backgroundColor
}) => {
    const { close } = Modal.useContext();

    const backgroundColorStyle =
        backgroundColor
            ? { '--background-color': backgroundColor } as ModalCloseBtnCSS
            : undefined;

    return (
        <button style={backgroundColorStyle}
            className={classNames(styles.closeButton, { [styles.showBackground]: hasBackground }, className)}
            onClick={() => {
                onClick();
                close();
            }}>
            <div className={iconClassName}>
                <CloseIcon size={12} color={iconColor}/>
            </div>
        </button>
    );
};

ModalCloseBtn.displayName = 'ModalCloseBtn';

export default ModalCloseBtn;
